import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'highlight',
    standalone: false
})
export class HighlightPipe implements PipeTransform {
  constructor(private readonly sanitizer: DomSanitizer) {}

  public transform(text: string, search: string, background = false): SafeHtml {
    if (search !== undefined && search.trim() && text) {
      let pattern = search.trim().replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
      pattern = pattern
        .split(' ')
        .filter(t => {
          return t.length > 0;
        })
        .join('|');
      const regex = new RegExp(pattern, 'gi');
      let className = `highlight`;
      className = background ? `${className} highlight-background` : className;
      return this.sanitizer.bypassSecurityTrustHtml(
        text.replace(regex, match => `<span class="${className}">${match}</span>`)
      );
    }
    return text;
  }
}
